import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./card-footer.css?inline";

@customElement("eko-card-footer")
export class CardFooter extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) alignment: "left" | "center" | "right" = "left";
  @property({ reflect: true }) padding: "lg" | "md" | "sm" = "lg";
  @property({ reflect: true }) variant: "card" | "page" = "card";

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card-footer": CardFooter;
  }
}

export default CardFooter;
